<template>
    <th @mouseenter="showButtons=true" @mouseleave="showButtons=false">
        <div class="inline">
            <slot v-if="hasSort && showButtons"></slot>

                <select v-if="filterActive && filterType === 'dropdown'" @input="handleInput" :value="filter" style="max-width: 95%; font-size: small; color: #525f7f;"
                        >
                    <option :value="null" selected>{{title}} wählen</option> -->
                    <option v-for="item in dropdownList" :key="item.id" :value="item.id">{{ item[property] }}</option>
                </select>


            <span v-else-if="filterActive && filterType === 'date'" style="max-width: 95%;"><flat-pickr
                        class="datepicker2"
                        :config="config"
                        v-on:input="handleInput"
                        :value="filter"></flat-pickr></span>

            <input v-else-if="filterActive && filterType === 'input'" type="text" @input="handleInput" :value="filter" class="mb-0" style="max-width: 95%; font-size: small; color: #525f7f;" :placeholder="title">

            <span v-else>{{title}}</span>

            <font-awesome-icon class="ml-1" v-if="hasFilter && showButtons" :icon="['fas', 'filter']"
                                                      @click="() => {if(filter !== null){filter = null; reset();} filterActive = !filterActive; }"></font-awesome-icon >
        </div>
    </th>
</template>
<script>


    import FlatPickr from "vue-flatpickr-component/src/component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    export default {
        name:'TableHeadFilter',
        components:{FlatPickr},
        props:{
            hasFilter: {
                type: Boolean,
                default: false
            },
            hasSort: {
                type: Boolean,
                default: false
            },
            filter:{},
            filterType: String,
            dropdownList:{},
            property: {
                type: String,
                default: 'name'
            },
            title: String,
        },
        model: {
            prop: 'filter',
            event: 'input'
        },
        data() {
            return {
                filterActive: false,
                showButtons: false,
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                }
            }
        },
        methods: {
            handleInput (evt) {
                let value = (typeof evt.target === 'undefined') ? evt : evt.target.value;
                this.$emit('input', value)
            },
            reset () {
                this.$emit('input', null)
            }
        }
    }
</script>

<style>
    .datepicker2 {
        border-radius: 0;
        border-width: 1px;
        border-color: grey;
        padding: 2px;
        display: inherit;
        width: 100% !important;
        font-size: small;
        color: #525f7f;
        height: inherit;
    }
</style>